(() => {
  const STORAGE_KEY = 'eaPageTransition';
  const STORAGE_KEY_CARRY = 'eaPreloaderProgressCarry';
  const html = document.documentElement;

  const preloader = () => document.getElementById('page-transition-preloader');
  const pctEl = () => document.getElementById('ea-preloader-pct-value');

  let mode = 'idle';
  let displayedProgress = 0;
  let targetProgress = 0;
  let animFrame = null;

  function renderProgress(p) {
    const clamped = Math.min(100, Math.max(0, p));

    const pct = pctEl();
    if (pct) pct.textContent = String(Math.round(clamped)).padStart(3, '0');

    const el = preloader();
    if (el) el.style.setProperty('--ea-print', (clamped / 100).toFixed(4));
  }

  function tick() {
    const diff = targetProgress - displayedProgress;
    const smoothing = mode === 'incoming' ? 0.2 : 0.14;
    if (Math.abs(diff) < 0.06) {
      displayedProgress = targetProgress;
    } else {
      displayedProgress += diff * smoothing;
    }
    renderProgress(displayedProgress);

    const el = preloader();
    const active =
      el &&
      (el.classList.contains('is-visible') || html.classList.contains('ea-preloader-pending'));

    if (!active) {
      animFrame = null;
      return;
    }

    if (mode === 'outbound') {
      targetProgress = Math.min(92, targetProgress + 0.58);
    }

    const moving = Math.abs(targetProgress - displayedProgress) > 0.035 || mode === 'outbound';
    if (moving || (mode === 'incoming' && displayedProgress < 99.6 && targetProgress >= 99)) {
      animFrame = requestAnimationFrame(tick);
    } else {
      animFrame = null;
    }
  }

  function startAnimationLoop() {
    if (animFrame == null) {
      animFrame = requestAnimationFrame(tick);
    }
  }

  function readCarriedProgress() {
    try {
      const raw = sessionStorage.getItem(STORAGE_KEY_CARRY);
      if (raw == null || raw === '') return 0;
      sessionStorage.removeItem(STORAGE_KEY_CARRY);
      const n = parseFloat(raw);
      if (Number.isNaN(n)) return 0;
      return Math.min(100, Math.max(0, n));
    } catch (_) {
      return 0;
    }
  }

  function show() {
    const el = preloader();
    if (!el) return;
    try {
      sessionStorage.removeItem(STORAGE_KEY_CARRY);
    } catch (_) {}
    mode = 'outbound';
    displayedProgress = 0;
    targetProgress = 0;
    renderProgress(0);
    el.classList.add('is-visible');
    el.setAttribute('aria-hidden', 'false');
    startAnimationLoop();
  }

  function clearPending() {
    try {
      sessionStorage.removeItem(STORAGE_KEY);
    } catch (_) {}
    html.classList.remove('ea-preloader-pending');
  }

  function finishIncoming() {
    const el = preloader();
    clearPending();
    mode = 'idle';
    if (animFrame != null) {
      cancelAnimationFrame(animFrame);
      animFrame = null;
    }
    if (!el) return;
    el.classList.remove('is-visible');
    el.setAttribute('aria-hidden', 'true');
    /* Reset progress UI once the curtain has lifted — avoids a visible snap */
    window.setTimeout(() => {
      if (mode !== 'idle') return;
      displayedProgress = 0;
      targetProgress = 0;
      renderProgress(0);
    }, 800);
  }

  window.addEventListener(
    'pagehide',
    () => {
      try {
        if (mode === 'outbound') {
          sessionStorage.setItem(STORAGE_KEY_CARRY, String(Math.min(100, Math.round(displayedProgress))));
        }
      } catch (_) {}
    },
    { capture: true }
  );

  function shouldHandleAnchor(anchor, event) {
    if (!anchor || anchor.closest('#page-transition-preloader')) return false;
    if (anchor.closest('cart-drawer')) return false;
    if (anchor.id === 'cart-icon-bubble') return false;
    if (anchor.getAttribute('aria-haspopup') === 'dialog') return false;
    if (anchor.dataset.noPageTransition !== undefined) return false;
    if (event.defaultPrevented) return false;
    if (event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return false;
    if (anchor.target && anchor.target !== '' && anchor.target.toLowerCase() !== '_self') return false;
    if (anchor.hasAttribute('download')) return false;
    const hrefAttr = anchor.getAttribute('href');
    if (!hrefAttr || hrefAttr.startsWith('#') || hrefAttr.startsWith('javascript:') || hrefAttr.startsWith('mailto:') || hrefAttr.startsWith('tel:')) {
      return false;
    }
    let url;
    try {
      url = new URL(anchor.href, window.location.href);
    } catch (_) {
      return false;
    }
    if (url.origin !== window.location.origin) return false;
    if (url.pathname === window.location.pathname && url.search === window.location.search && url.hash !== '') {
      return false;
    }
    return true;
  }

  document.addEventListener(
    'click',
    (event) => {
      if (window.Shopify && Shopify.designMode) return;
      const anchor = event.target.closest && event.target.closest('a[href]');
      if (!shouldHandleAnchor(anchor, event)) return;
      try {
        sessionStorage.setItem(STORAGE_KEY, '1');
      } catch (_) {}
      show();
      window.setTimeout(() => {
        if (event.defaultPrevented) finishIncoming();
      }, 0);
    },
    true
  );

  window.addEventListener('pageshow', (event) => {
    if (event.persisted) {
      try {
        sessionStorage.removeItem(STORAGE_KEY_CARRY);
      } catch (_) {}
      finishIncoming();
    }
  });

  function runIncomingProgress() {
    if (!html.classList.contains('ea-preloader-pending')) return;

    const carried = readCarriedProgress();

    mode = 'incoming';
    displayedProgress = carried;
    targetProgress = carried > 0 ? carried : 16;
    renderProgress(displayedProgress);
    startAnimationLoop();

    const bumpDom = () => {
      targetProgress = Math.max(targetProgress, 56);
      startAnimationLoop();
    };

    const finishLoad = () => {
      targetProgress = 100;
      startAnimationLoop();
      window.setTimeout(() => {
        finishIncoming();
      }, 520);
    };

    if (document.readyState !== 'loading') {
      bumpDom();
    } else {
      document.addEventListener('DOMContentLoaded', bumpDom, { once: true });
    }

    if (document.readyState === 'complete') {
      finishLoad();
    } else {
      window.addEventListener('load', finishLoad, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', runIncomingProgress);
  } else {
    runIncomingProgress();
  }
})();
